document.addEventListener("DOMContentLoaded", function() {
    function isColorDark(hex) {
        if (!hex) return false;
        hex = hex.replace("#", "");
        if (hex.length === 3) hex = hex.split("").map(c => c + c).join("");
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance < 0.5;
    }

    document.querySelectorAll(".color-box").forEach(function(box) {
        const bgColor = box.style.backgroundColor;
        const hexMatch = bgColor.match(/^#([0-9A-Fa-f]{3,6})$/);

        let hex = null;
        if (hexMatch) {
            hex = hexMatch[0];
        } else {
            const rgbMatch = bgColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
            if (rgbMatch) {
                const r = parseInt(rgbMatch[1]).toString(16).padStart(2, "0");
                const g = parseInt(rgbMatch[2]).toString(16).padStart(2, "0");
                const b = parseInt(rgbMatch[3]).toString(16).padStart(2, "0");
                hex = `#${r}${g}${b}`;
            }
        }

        const logo = box.querySelector(".color-logo img");

        if (hex && isColorDark(hex)) {
            box.classList.add("light-text");
            if (logo) logo.src = window.colorLogos.white;
        } else {
            box.classList.add("dark-text");
            if (logo) logo.src = window.colorLogos.black;
        }
    });
});
